import { Button } from "antd";
import "./button.scss"
export default Button;
